<template>
  <div class="login__form">
    <form @submit.prevent="$emit('login', login)" class="form">
      <img src="@/assets/logo.png" width="180" alt="Invision Logo" />
      <p class="login__title">Log in to the QHA (Quality Health Advice) Tool</p>
      <p class="error" v-if="error">{{ error }}</p>
      <div class="field">
        <span class="icon input-icon">
          <i class="far fa-envelope"></i>
        </span>
        <input
          type="text"
          class="input has-icon"
          autocomplete="username"
          name="username"
          placeholder="Your email address"
          v-model="login.email"
          @input="$emit('clear-error')"
        />
      </div>
      <div class="field">
        <span class="icon input-icon">
          <svg
            width="20"
            height="22"
            viewBox="0 0 20 22"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17 22H3C1.3 22 0 20.7 0 19V12C0 10.3 1.3 9 3 9H17C18.7 9 20 10.3 20 12V19C20 20.7 18.7 22 17 22ZM3 11C2.4 11 2 11.4 2 12V19C2 19.6 2.4 20 3 20H17C17.6 20 18 19.6 18 19V12C18 11.4 17.6 11 17 11H3Z"
            />
            <path
              d="M5 11C4.4 11 4 10.6 4 10V6C4 4.4 4.6 2.9 5.8 1.8C6.9 0.6 8.4 0 10 0C12.8 0 15.3 2 15.9 4.8C16 5.3 15.6 5.9 15.1 6C14.6 6.1 14 5.8 13.9 5.2C13.5 3.3 11.9 2 10 2C8.9 2 7.9 2.4 7.2 3.2C6.4 3.9 6 4.9 6 6V10C6 10.6 5.6 11 5 11Z"
            />
          </svg>
        </span>
        <input
          type="password"
          class="input has-icon"
          autocomplete="current-password"
          name="password"
          placeholder="Your password"
          v-model="login.password"
          @input="$emit('clear-error')"
        />
      </div>
      <div>
        <p class="disclaimer forgot-link">
          <router-link to="/forgotten">
            Forgot Password?
          </router-link>
        </p>
        <button class="login__button">Log in</button>
        <p class="disclaimer">
          By clicking 'Log in' you hereby accept the conditions set out in our
          <a href="https://innovateservices.com/privacy-policy/"
            >Privacy Policy</a
          >
        </p>
      </div>
      <hr />
      <p class="disclaimer">
        If you need to access the QHA (Quality Health Advice) Tool for the first
        time, or have forgotten your password, contact your super user.
      </p>
    </form>
  </div>
</template>

<script>
export default {
  name: 'LoginForm',
  props: ['error'],
  data() {
    return {
      login: {
        email: '',
        password: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/style/variables.scss";
@import "@/style/components.scss";
@import "@/style/login.scss";

.disclaimer {
  text-align: center;
  font-size: 0.8rem;
}

.error {
  color: red;
  text-align: center;
}

.forgot-link {
  text-align: right;
  margin-bottom: 15px;
}
</style>
